import { render, staticRenderFns } from "./message-image.vue?vue&type=template&id=615271f6&scoped=true"
import script from "./message-image.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-image.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-image.vue?vue&type=style&index=0&id=615271f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615271f6",
  null
  
)

export default component.exports